var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticStyle:{"max-height":"300px"},attrs:{"src":_vm.getVehiclesQRCode()}})
}
var staticRenderFns = []

export { render, staticRenderFns }